/* OCG "Complete the kit", AU version (8 Oct 2026), same behaviour as the live US file. Loaded once from layout/theme.liquid.
 * Works with snippets/ocg-complete-kit.liquid. No dependencies (uses the theme's geckoShopify / jQuery when present).
 * AU theme (Kalles / Gecko): product form = form.nt_cart_form [name=id]; sizes are .swatch_pr_item swatches;
 * the drawer and /cart are refreshed by geckoShopify.onCartUpdate (?view=js / ?view=pagejs), which re-renders the block.
 * - Size select per piece. The size follows the jersey size ONLY after the customer clicks a
 *   size (the PDP opens on XXS on purpose, so the preselected XXS is never copied).
 * - Colour follows the jersey colour when the piece has that colour value.
 * - Add = POST /cart/add.js with one variant id, then the theme's own event
 *   'cart:refresh:opend' refreshes and opens the drawer (same event the theme listens to in
 *   assets/interactable.min.js). No Bold line-item properties are sent.
 * - Option names are translated on non-English storefronts, so the Size option is found by
 *   its VALUES (XXS..7XL), never by its name.
 */
(function () {
  'use strict';
  if (window.__ocgCtkLoaded) return;
  window.__ocgCtkLoaded = true;

  var SIZE_SCALE = ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL', '6XL', '7XL', '8XL', '9XL'];
  var jerseySizePicked = null;   // set only by a real customer click/change on the PDP
  var jerseyColor = null;

  function sizeIndex(options) {
    for (var i = 0; i < options.length; i++) {
      var vals = options[i].values || options[i];
      if (vals && vals.length && vals.every(function (v) { return SIZE_SCALE.indexOf(String(v).toUpperCase()) > -1; })) return i;
    }
    return -1;
  }
  function otherIndex(options, si) {
    for (var i = 0; i < options.length; i++) if (i !== si && (options[i].values || []).length > 1) return i;
    return -1;
  }
  function i18n(root) {
    var el = root.querySelector('[data-ctk-i18n]') || document.querySelector('[data-ctk-i18n]');
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  function money(cents, fmt) {
    var out;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') out = String(window.Shopify.formatMoney(cents, fmt));
    else {
      var f = String(fmt || '${{amount}}').replace(/<[^>]*>/g, '');
      var v = (cents / 100).toFixed(2);
      out = f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100))).replace(/\{\{\s*\w+\s*\}\}/, v);
    }
    // the store money format wraps amounts in <span class=money>; this text goes into textContent
    return out.replace(/<[^>]*>/g, '');
  }

  /* ---------- read the jersey selection on the PDP ---------- */
  function mainForm() {
    var sec = document.querySelector('[id^="shopify-section-pr_summary"]') || document;
    var f = sec.querySelector('form.nt_cart_form') || document.querySelector('form.nt_cart_form');
    return f && f.querySelector('[name="id"]') ? f : null;
  }
  function mainVariants() {
    var s = document.querySelector('[data-ocg-ctk][data-context="pdp"] [data-ctk-src-json]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function currentJerseyVariant() {
    var f = mainForm(); if (!f) return null;
    var idEl = f.querySelector('[name="id"]'); if (!idEl) return null;
    var list = mainVariants() || [];
    var id = Number(idEl.value);
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }
  function readJersey(fromUser) {
    var v = currentJerseyVariant(); if (!v) return;
    var opts = v.options || [];
    var sIdx = -1;
    opts.forEach(function (o, i) { if (SIZE_SCALE.indexOf(String(o).toUpperCase()) > -1) sIdx = i; });
    opts.forEach(function (o, i) { if (i !== sIdx) jerseyColor = o; });
    if (fromUser && sIdx > -1) jerseySizePicked = opts[sIdx];
  }

  /* ---------- build the controls for one item ---------- */
  function setupItem(item, ctx, t, srcSize) {
    // custom pieces (upload / design on their own page): plain link, no options, no quick add, left out of the shipping maths
    if (item.hasAttribute('data-ctk-link')) return;
    var data;
    try { data = JSON.parse(item.querySelector('[data-ctk-json]').textContent); } catch (e) { item.hidden = true; return; }
    var options = (data.options || []).map(function (name, i) {
      var vals = [];
      data.variants.forEach(function (v) { var x = v.options[i]; if (vals.indexOf(x) < 0) vals.push(x); });
      return { name: name, values: vals };
    });
    var si = sizeIndex(options), ci = -1;
    // AU 9 Oct 2026: the colour option is found by its name (Color / Colour) when there is one, else the first other option
    // with several values; any further option (e.g. Style: Classic / No padding) stays on its first value in stock.
    options.forEach(function (o, i) { if (ci < 0 && i !== si && /^colou?r$/i.test(String(o.name).trim()) && o.values.length > 1) ci = i; });
    if (ci < 0) ci = otherIndex(options, si);
    var fixed = {};
    options.forEach(function (o, i) {
      if (i === si || i === ci || o.values.length < 2) return;
      fixed[i] = o.values.filter(function (val) { return data.variants.some(function (v) { return v.available && v.options[i] === val; }); })[0] || o.values[0];
    });
    function fixedOk(v) { for (var k in fixed) if (v.options[k] !== fixed[k]) return false; return true; }
    var isNeutral = item.hasAttribute('data-neutral');
    var box = item.querySelector('[data-ctk-opts]');
    var sel = null;
    if (si > -1) {
      sel = document.createElement('select');
      sel.className = 'ocg-ctk__sel';
      sel.setAttribute('aria-label', (t.select_size || 'Select size'));
      var ph = document.createElement('option'); ph.value = ''; ph.textContent = t.select_size || 'Select size'; sel.appendChild(ph);
      options[si].values.forEach(function (val) {
        var ok = data.variants.some(function (v) { return v.options[si] === val && v.available; });
        var o = document.createElement('option'); o.value = val; o.textContent = ok ? val : val + ' (' + (t.sold_out || 'Sold out') + ')'; o.disabled = !ok;
        sel.appendChild(o);
      });
      box.appendChild(sel);
      var need = document.createElement('span'); need.className = 'ocg-ctk__need'; need.textContent = t.pick_size || 'Pick a size'; need.setAttribute('role', 'alert');
      box.appendChild(need);
      sel.addEventListener('change', function () { sel.dataset.userSet = '1'; sel.classList.remove('is-need'); });
    } else {
      var one = document.createElement('span'); one.textContent = t.one_size || 'One size'; box.appendChild(one);
    }
    var colorEl = null, colorSel = null;
    if (ci > -1) {
      colorEl = document.createElement('span'); colorEl.className = 'ocg-ctk__color'; box.appendChild(colorEl);
      // shown only when the jersey colour does not exist on this piece: never guess a colour for the customer
      colorSel = document.createElement('select'); colorSel.className = 'ocg-ctk__sel'; colorSel.hidden = true;
      colorSel.setAttribute('aria-label', options[ci].name);
      var cph = document.createElement('option'); cph.value = ''; cph.textContent = (t.select_color || 'Select color'); colorSel.appendChild(cph);
      options[ci].values.forEach(function (val) { var o = document.createElement('option'); o.value = val; o.textContent = val; colorSel.appendChild(o); });
      box.appendChild(colorSel);
      var cneed = document.createElement('span'); cneed.className = 'ocg-ctk__need'; cneed.textContent = t.pick_color || 'Pick a color'; box.appendChild(cneed);
      colorSel.addEventListener('change', function () { colorSel.classList.remove('is-need'); item.dataset.color = colorSel.value; });
      // neutral pieces (no design match): the colour never follows the jersey. Preset the default
      // colour from theme settings (Graziela's link), else the first colour in stock; the customer can change it.
      if (isNeutral) {
        var dc = item.dataset.defaultColor;
        var okc = function (c) { return data.variants.some(function (v) { return v.available && v.options[ci] === c; }); };
        if (!dc || options[ci].values.indexOf(dc) < 0 || !okc(dc)) dc = options[ci].values.filter(okc)[0] || '';
        colorSel.value = dc;
      }
    }

    function sync() {
      var size = ctx === 'pdp' ? jerseySizePicked : srcSize;
      if (sel && !sel.dataset.userSet && size) {
        var opt = [].find.call(sel.options, function (o) { return o.value === size && !o.disabled; });
        sel.value = opt ? size : '';
      }
      if (colorEl) {
        var match = !isNeutral && options[ci].values.indexOf(jerseyColor) > -1;
        colorEl.hidden = !match; colorSel.hidden = match;
        var col = match ? jerseyColor : colorSel.value;
        item.dataset.color = col || '';
        colorEl.textContent = match ? options[ci].name + ': ' + col : '';
        if (!col) return;
        var v = data.variants.find(function (x) { return x.options[ci] === col && x.featured_image; });
        var img = item.querySelector('[data-ctk-img]');
        if (v && img) { img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; img.removeAttribute('srcset'); }
      }
    }
    function pickVariant() {
      var size = sel ? sel.value : null, col = item.dataset.color || null;
      return data.variants.find(function (v) {
        return v.available && fixedOk(v) && (si < 0 || v.options[si] === size) && (ci < 0 || !col || v.options[ci] === col);
      }) || data.variants.find(function (v) {
        return v.available && (si < 0 || v.options[si] === size) && (ci < 0 || !col || v.options[ci] === col);
      }) || (si > -1 ? data.variants.find(function (v) { return v.available && v.options[si] === size; }) : data.variants.find(function (v) { return v.available; }));
    }
    item._ctk = { sync: sync, pickVariant: pickVariant, sel: sel, colorSel: colorSel, price: data.variants[0] ? data.variants[0].price : 0 };
    sync();
  }

  /* ---------- free-shipping hint (PDP) and "Reaches $X" tags (cart) ---------- */
  function refreshShip(root, t, cart) {
    var thr = Number(root.dataset.threshold || 0); if (!thr || !cart) return;
    var items = [].slice.call(root.querySelectorAll('[data-ctk-item]')).filter(function (i) { return !i.hidden && i._ctk; });
    var total = cart.total_price;
    if (root.dataset.context === 'pdp') {
      var inCart = cart.items.some(function (l) { return l.handle === root.dataset.srcHandle; });
      var jv = currentJerseyVariant();
      var base = total + (inCart || !jv ? 0 : jv.price);
      var line = root.querySelector('[data-ctk-ship]'); if (!line) return;
      if (base >= thr) { line.textContent = t.ship_free || ''; line.hidden = !line.textContent; return; }
      var best = null, n = items.length;
      for (var m = 1; m < (1 << n); m++) {
        var set = items.filter(function (_, i) { return m & (1 << i); });
        var tot = base + set.reduce(function (a, i) { return a + i._ctk.price; }, 0);
        if (tot >= thr && (!best || set.length < best.set.length || (set.length === best.set.length && tot < best.tot))) best = { set: set, tot: tot };
      }
      if (!best) { line.hidden = true; return; }
      var names = best.set.map(function (i) { return i.querySelector('.ocg-ctk__name').textContent.trim(); }).join(' + ');
      var lead = inCart ? t.lead_cart : (t['lead_' + (root.dataset.srcRole || 'jersey')] || t.lead_jersey);
      line.textContent = (t.ship_combo || '').replace('[lead]', lead || '').replace('[items]', names).replace('[total]', money(best.tot, t.money_format));
      line.hidden = false;
    } else {
      var gap = thr - total;
      items.forEach(function (i) {
        var tag = i.querySelector('[data-ctk-reaches]');
        if (tag) tag.hidden = !(gap > 0 && i._ctk.price >= gap);
      });
    }
  }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function add(item, root, t) {
    var c = item._ctk;
    if (c.colorSel && !c.colorSel.hidden && !c.colorSel.value) { c.colorSel.classList.add('is-need'); c.colorSel.focus(); return; }
    if (c.sel && !c.sel.value) { c.sel.classList.add('is-need'); c.sel.focus(); return; }
    var v = c.pickVariant(); if (!v) return;
    var btn = item.querySelector('[data-ctk-add]');
    btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: { _ctk: root.dataset.context || 'pdp' } }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        btn.textContent = t.added || 'Added';
        btn.classList.add('is-done');
        // the theme's own refresh: re-renders the drawer (or /cart) and runs its after-add action (open the drawer)
        var pid = Number(item.dataset.productId) || 19041994;
        if (window.geckoShopify && typeof window.geckoShopify.onCartUpdate === 'function') window.geckoShopify.onCartUpdate(1, 1, pid);
        if (window.jQuery) window.jQuery('body').trigger('CartUpdateSuccess');
        document.dispatchEvent(new CustomEvent('ocg:ctk:added'));
      })
      .catch(function () {
        btn.disabled = false;
        var msg = root.querySelector('[data-ctk-msg]'); if (msg) msg.textContent = t.error || '';
      });
  }

  function init(root) {
    if (root.__ctk) return; root.__ctk = true;
    var t = i18n(root), ctx = root.dataset.context;
    var srcSize = null;
    if (ctx === 'cart' && root.dataset.srcVariant) {
      // size and colour of the cart line we are completing
      getCart().then(function (cart) {
        var line = cart.items.find(function (l) { return String(l.variant_id) === root.dataset.srcVariant; });
        if (line) {
          (line.variant_options || []).forEach(function (o) {
            if (SIZE_SCALE.indexOf(String(o).toUpperCase()) > -1) srcSize = o; else jerseyColor = o;
          });
        }
        root.querySelectorAll('[data-ctk-item]').forEach(function (i) { setupItem(i, ctx, t, srcSize); });
        refreshShip(root, t, cart);
      });
    } else {
      readJersey(false);
      root.querySelectorAll('[data-ctk-item]').forEach(function (i) { setupItem(i, ctx, t, null); });
      getCart().then(function (cart) { refreshShip(root, t, cart); });
      var f = mainForm();
      if (f) {
        // a click on any size swatch or a change of the variant select counts as a real choice
        f.addEventListener('change', function (e) {
          // the theme fires a synthetic change on the variant input when the page loads (default XXS): only a real one counts
          if (!e.isTrusted) return;
          if (e.target && e.target.name === 'id') { readJersey(true); root.querySelectorAll('[data-ctk-item]').forEach(function (i) { i._ctk && i._ctk.sync(); }); getCart().then(function (c) { refreshShip(root, t, c); }); }
        });
        var area = f.closest('.oddit_variant') || f.parentElement;
        document.addEventListener('click', function (e) {
          var sw = e.target.closest && e.target.closest('.swatch_pr_item, [data-swatch-item]');
          if (!sw || !area.contains(sw)) return;
          setTimeout(function () { readJersey(true); root.querySelectorAll('[data-ctk-item]').forEach(function (i) { i._ctk && i._ctk.sync(); }); getCart().then(function (c) { refreshShip(root, t, c); }); }, 200);
        }, true);   // capture: the theme's swatch handler stops the click from bubbling
      }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ctk-add]'); if (!b) return;
      add(b.closest('[data-ctk-item]'), root, t);
    });
  }

  function boot() {
    document.querySelectorAll('[data-ocg-ctk]').forEach(init);
    // hide the theme's "Frequently bought together" carousel in the drawer while the block is there (CSS :has does it too)
    document.documentElement.classList.toggle('ocg-ctk-in-drawer', !!document.querySelector('#nt_cart_canvas [data-ocg-ctk]'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // the theme replaces the drawer / cart items HTML after every cart change (jQuery .html), so watch for new blocks
  var pending = null;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].addedNodes;
      for (var j = 0; j < n.length; j++) {
        if (n[j].nodeType === 1 && (n[j].matches('[data-ocg-ctk]') || n[j].querySelector('[data-ocg-ctk]'))) {
          clearTimeout(pending); pending = setTimeout(boot, 60); return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (window.jQuery) window.jQuery('body').on('CartUpdateSuccess CartChangeSuccess', function () { setTimeout(boot, 400); });
})();
